import * as logisticModels from './logisticModels';

const reducers = {
  ...logisticModels,
};

export default reducers;
